// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"d8348882","786":"46dd4a03","855":"c22105be","930":"22f4a228"}[chunkId] + ".chunk.css";
};